module.exports = __webpack_public_path__ + "img/po3.49940dc4.jpg";